import { Helmet } from 'react-helmet-async';
import { useSelector } from 'react-redux';
import { RootState } from 'src/redux-store/appStore';
import { Grid, Container } from '@mui/material';
import ProfileCover from './ProfileCover';

function ManagementUserProfile() {
  const userData = useSelector((store: RootState) => store.user.userDetails);
  const townshipDetails = useSelector(
    (store: RootState) => store.township.townshipDetails
  );

  // Default avatar path when no user image is available
  const defaultAvatar = '/static/images/avatars/default-avatar.png';
  
  // Get user avatar from userData if available, otherwise use default
  const userAvatar = userData?.ProfilePicture || userData?.ImageURL || userData?.ProfileImage || userData?.Avatar || defaultAvatar;

  const user = {
    savedCards: 0,
    name: `${userData.FirstName} ${userData.LastName}`,
    coverImg: '/static/images/placeholders/covers/7.jfif',
    avatar: userAvatar,
    description: `There are many variations of passages of Lorem Ipsum available, 
    but the majority have suffered alteration in some form, by injected humour, 
    or randomised words which don't look even slightly believable. If you are going to use a passage`,
    jobtitle: userData.UserRole === 'Vendor' ? 'User' : userData.UserRole,
    location: townshipDetails?.name,
    followers: '1'
  };

  return (
    <>
      <Helmet>
        <title>User Profile</title>
      </Helmet>
      <Container sx={{ mt: 3 }} maxWidth="lg">
        <Grid
          container
          justifyContent="center"
          alignItems="stretch"
          spacing={3}
        >
          <Grid item xs={12}>
            <ProfileCover user={user} />
          </Grid>
        </Grid>
      </Container>
    </>
  );
}

export default ManagementUserProfile;
